import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import Categories from './categories';
import {toJS} from "../hocs/toJs";
import {formValueSelector} from "redux-form/immutable";

const selector = formValueSelector('sortCategoriesForm');

const parsePillars = (pillars) => {
  const parsedPillars = [];
  pillars.valueSeq().toArray().forEach(pillar => {
    parsedPillars.push({
      id: pillar.get('id'),
      name: pillar.get('name'),
    })
  });
  return parsedPillars;
};


const parseCategories = (categories) => {
  const parsedCategories = [];
  categories.valueSeq().toArray().forEach( category => (
    parsedCategories.push({
      id: category.get('id'),
      name: category.get('name'),
      weightOld: category.get('weightOld'),
      weightNew: category.get('weightNew'),
      weightNewComing: category.get('weightNewComing'),
      createdDate: category.get('createdDate'),
      pillarId: category.get('pillarId'),
      pillar: category.get('pillar')?{
        id: category.getIn(['pillar', 'id']),
        name: category.getIn(['pillar', 'name']),
      }:{},
    })));
  return parsedCategories;
};

class CategoriesHOC extends Component {

  componentDidMount() {
    this.props.getPillars({filter:{where: {or: [{deleted: false}, {deleted: null}]}}});
    this.props.getCategories({filter:{
          where: {or: [{deleted: false}, {deleted: null}]},
          include: 'pillar'
        }
    })
  }

  render(){
    return (
      <Categories
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.categories.get('categories'),
    loading: state.categories.get('fetching'),
    pillars: state.pillars.get('pillars'),
    categoriesErrors: state.categories.get('errors'),
    deletingCategory: state.category.get('deleting'),
    mobileViewSortBy: selector(state, 'sortBy'),
    mobileViewSortOrder: selector(state, 'sortOrder'),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCategories: (payload) => {
      dispatch(actions.getCategories(payload))
    },
    getPillars: (payload) => {
      dispatch(actions.getPillars(payload))
    },
    changeCategoriesState: (payload) => {
      dispatch(actions.changeCategoriesState(payload))
    },
    getCategoriesWithFilters: (payload) => {
      dispatch(actions.getCategoriesWithFilters(payload))
    },
    deleteCategory: (payload) => {
      dispatch(actions.deleteCategory(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(CategoriesHOC));



// WEBPACK FOOTER //
// ./src/components/categories/categoriesHOC.js